module.exports = __webpack_public_path__ + "static/media/output.be36b33b.mp4";